module.exports = __webpack_public_path__ + "img/uwzorgonline-iphone.04dbafb8.png";